import { ErrorCodes } from '@sharefiledev/storage-plugin-pilet-sdk';
import axios, { AxiosInstance } from 'axios';
import { EventSourcePolyfill } from 'event-source-polyfill';
import { errorNotification } from '../components/common';
import { defaultT } from '../translate';
interface Configuration {
	origin: string;
	apiPath: string;
	ssePath: string;
}

const configuration: Configuration = {
	origin: window.origin,
	apiPath: '/io/storage/api',
	ssePath: '/io/storage/sse',
};

export const apiClient = axios.create({
	baseURL: configuration.origin + configuration.apiPath,
	headers: {
		'X-BFF-CSRF': 'true',
	},
});

apiClient.interceptors.response.use(
	response => response,
	error => {
		// upload errors are handled in the upload component
		// the below error codes have custom error handling. Hence excluding them from generic error handling.
		const customHandledCodes = [400, 401, 403, 404, 409, 412, 422, 500];
		if (
			(error.responseText !== 'aborted' &&
				error.config &&
				error.config.baseURL.includes(configuration.apiPath) &&
				!customHandledCodes.includes(error.response.status) &&
				!(error.response?.data?.statusCode === ErrorCodes.StorageConfigurationMissing)) ||
			error.config.url?.includes('/preview')
		) {
			const errorMessage =
				error.response && error.response.status === 401
					? defaultT('error.unauthorized')
					: defaultT('error.generic_error');
			errorNotification(errorMessage);
		} else {
			throw error;
		}
	}
);

export const apiClientForPatch = axios.create({
	baseURL: configuration.origin + configuration.apiPath,
	headers: {
		'X-BFF-CSRF': 'true',
		'Content-Type': 'application/json-patch+json',
	},
});

export function configureHttp(
	configure: (current: Configuration, currentclient: AxiosInstance) => void
) {
	configure(configuration, apiClient);
}

// Replace your existing getSseClient function
export function getSseClient(relativeUrl: string): EventSourcePolyfill {
	const fullUrl = `${configuration.origin}${configuration.ssePath}${relativeUrl}`;

	const headers: Record<string, string> = {
		'X-BFF-CSRF': 'true',
	};

	const sse = new EventSourcePolyfill(fullUrl, {
		withCredentials: true,
		headers,
	});

	return sse;
}
